import { ProductName } from "../CurrentPlan/constants";

// 账单周期类型定义
export const BillingCycle = {
  MONTH: "MONTH",
  YEAR: "YEAR",
  WEEK: "WEEK",
  LIFETIME: "LIFETIME",
} as const;

// 圣诞活动折扣值
export const DiscountValue = 40;
export const DiscountValueYearlyPrice = 360;

// 基础折扣值映射
export const DiscountValueMaps: Record<string, Record<string, number>> = {
  [ProductName.Pro]: {
    [BillingCycle.MONTH]: 32.99,
    [BillingCycle.YEAR]: 44.45,
  },
  [ProductName.Expert]: {
    [BillingCycle.MONTH]: 29.99,
    [BillingCycle.YEAR]: 41.67,
  },
} as const;
